<template>
	<div style="z-index: 999999; position: fixed; display: block;">
		<!-- Overlapped Activities -->
		<modal
			:modal="overlappedActivitiesModal"
			v-if="overlappedActivitiesModal.show"
		>
			<div class style="margin: 20px auto; max-width: 350px;">
				<div class="text-center mb-3">
					<i class="material-icons text-pencil" style="font-size: 100px"
						>access_time</i
					>
					<p>
						This is a friendly alert letting you know this experience has an
						overlapping time with another item already in your cart.<br /><br />
						If this is intentional, you can continue on.<br /><br />
						If this isn't intentional, you can cancel and select a different
						date/time.
						<!-- <strong>Whoops.</strong> You have selected events with overlapping
            times. Choose different date and/or times. -->
					</p>
				</div>

				<!-- <pre>overlappedActivitiesModal.data: {{overlappedActivitiesModal.data}}</pre> -->

				<!-- <div class="mt-1 mb-1" v-for="product in overlappedActivitiesModal.data.Individuals">
          <div class="flex" v-for="activity in product.Activities">
            <span>{{activity.ActivityName}}&nbsp;</span>
            <span>{{activity.AppointmentDate}}&nbsp;</span>
            <span>{{activity.StartTime}}</span>
          </div>
        </div>

        <div class="mt-1 mb-1" v-for="product in overlappedActivitiesModal.data.Packages">
          <h4 class="mb-0">{{product.Name}} Package</h4>
          <div class="flex" v-for="activity in product.Activities">
            <span>{{activity.ActivityName}}&nbsp;</span>
            <span>{{activity.AppointmentDate}}&nbsp;</span>
            <span>{{activity.StartTime}}</span>
          </div>
        </div>-->

				<!-- <p class="text-center mt-3 mb-2">Would you like to continue anyway?</p> -->
			</div>

			<template v-slot:footer>
				<button
					:disabled="addToCartLoading"
					@click.prevent="$emit('overlappedActivitiesModalNo', {})"
					class="button blue-outline"
				>
					Cancel
				</button>
				<button
					:disabled="addToCartLoading"
					@click.prevent="$emit('overlappedActivitiesModalYes', {})"
					class="button blue-continue ml-1"
					:class="{ button_loading: addToCartLoading }"
				>
					Continue
				</button>
			</template>
		</modal>

		<!-- Taken Times-->
		<modal :modal="takenTimesModal" v-if="takenTimesModal.show">
			<div class style="margin: 20px auto; max-width: 350px">
				<div class="text-center">
					<i class="material-icons text-pencil" style="font-size: 80px"
						>access_time</i
					>
					<p>These times are no longer available.</p>
				</div>
				<pre v-if="postAddToCartJson && postAddToCartJson.TakenTimes">
postAddToCartJson: {{ postAddToCartJson.TakenTimes }}</pre
				>
				<!-- <div>TODO: loop over each TakenTimes.</div> -->
				<div class="pt-1">
					<template v-for="(taken, index) in takenTimesModal.data">
						<div class="flex mt-1" :key="'taken-times-errors-' + index">
							<section>
								<span class="text-blue">{{ taken.Name }}</span>
								<br />
								<small>{{ taken.Date }}</small>
							</section>
							<strong>@{{ taken.Time }}</strong>
						</div>
					</template>
				</div>
			</div>

			<template v-slot:footer>
				<button
					@click.prevent="$emit('takenTimesModalOk', {})"
					class="button blue ml-1"
					:class="{ button_loading: addToCartLoading }"
				>
					Try again
				</button>
			</template>
		</modal>

		<!-- Taken Times-->
		<modal :modal="modelErrorsModal" v-if="modelErrorsModal.show">
			<div class="text-center mt-2 mb-2">
				<i class="material-icons text-pencil" style="font-size: 100px">error</i>
				<p>Correct these errors.</p>
				<!-- <pre>{{modelErrorsModal.data}}</pre> -->
				<div
					class="text-red shake-animation"
					v-for="(err, i) in modelErrorsModal.data"
					:key="'add-to-cart-model-errors-' + i"
				>
					<!-- <pre>{{err.Value}}</pre> -->
					<div
						class="mb-1"
						:key="'add-to-cart-model-error-' + i + '-' + n"
						v-for="(val, n) in err.Value"
					>
						{{ val }}
					</div>
				</div>
			</div>

			<template v-slot:footer>
				<button
					@click.prevent="$emit('modelErrorsModalOk', {})"
					class="button blue ml-1"
					:class="{ button_loading: addToCartLoading }"
				>
					OK
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	/*

    this file will work in conjuction with the mixins/addToCart.js

    if will handle the UI for any post-add-to-cart messages

*/

	export default {
		name: 'PostAddToCartModals',
		props: [
			'postAddToCartJson',
			'overlappedActivitiesModal',
			'takenTimesModal',
			'modelErrorsModal',
			'addToCartLoading',
			'isPackage',
		],
		mounted() {
			//alert("PostAddToCartModals");
		},
	};
</script>

<style>
	.blue-outline {
		background: transparent;
		border: 2px solid #09f;
		color: #09f;
		font-weight: 500;
	}

	.blue-continue {
		background: #09f;
		border: 2px solid #09f;
	}
</style>
